import {
  isArray,
  isArrayLen,
  isEmptyObject,
  isNumber,
  isObject,
  isString,
} from '@/utils/common/dataJudgment';
// type
import type { optsTypes } from './typings';

// 获取纯净子级选中信息
export const selectTreeChildren = ({
  selectValue,
  dataList,
}: {
  selectValue: any;
  dataList: any[];
}) => {
  const options: optsTypes[] = [];
  for (let i = 0; i < dataList.length; i++) {
    const item = dataList[i];
    if (item?.children?.length) {
      item?.children?.map((v: optsTypes) => {
        if (
          selectValue?.includes(v.id) &&
          !options.some((h: optsTypes) => h.id === v.id)
        )
          options.push(v);
      });
    }
  }

  return {
    selectChildValue: options.map((i) => i.id) || [],
    selectChildList: options || [],
  };
};

// 值是否为真
export const checkValue = (selectValue: any) => {
  if (isNumber(selectValue) || isString(selectValue)) return selectValue;
  if (selectValue && isArray(selectValue)) return isArrayLen(selectValue);
  if (selectValue && isObject(selectValue)) return isEmptyObject(selectValue);
  return selectValue;
};
